export default "__VITE_ASSET__BRv7TI10__"